import styled from 'styled-components';

var AlignRight = styled.div.withConfig({
  displayName: "AlignRight",
  componentId: "sc-c6fpek-0"
})(["display:flex;margin-left:auto;align-items:center;"]);

export { AlignRight };
